"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));
var _styled = _interopRequireDefault(require("../styled"));
var _BaseButton = _interopRequireDefault(require("./BaseButton"));
var _templateObject;
var preventDefault = function preventDefault(event) {
  return event.preventDefault();
};
var LinkButton = (0, _styled.default)(_BaseButton.default).attrs(function (props) {
  return {
    as: props.as || 'a',
    onClick: props.disabled ? preventDefault : undefined,
    tabIndex: props.disabled ? -1 : props.tabIndex
  };
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: inline-block;\n  text-decoration: none;\n  white-space: nowrap;\n"])));
var _default = exports.default = LinkButton;